module.exports = __webpack_public_path__ + "static/img/kefu.bf101e20.png";